import React from 'react';
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap';
import './TimeOffModal.scss';

function TimeOffModal({ isOpen, toggle, config }) {
  const { title, data } = config;

  const renderBody = () => {
    if (data?.length === 0) {
      return (
        <tr>
          <td colSpan="7" className="text-center">
            No data available
          </td>
        </tr>
      );
    }

    return data.map(item => (
      <tr key={item.id}>
        <td>{item.TransNo}</td>
        <td>{item['Leave Type']}</td>
        <td>{item['From Date']}</td>
        <td>{item['To Date']}</td>
        <td>{item.Days}</td>
        <td>{item['Approved By']}</td>
        <td>{item.Reason}</td>
      </tr>
    ));
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xl">
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <div
          className="table-responsive"
          style={{
            border: '2px solid #D0D5DD',
            borderRadius: '8px',
          }}
          id="time-off-modal-table"
        >
          <Table className="custom-table mb-0">
            <thead>
              <tr>
                <th>Trans No.</th>
                <th>Leave Type</th>
                <th>From Date</th>
                <th>To Date</th>
                <th>Days</th>
                <th>Approved By</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>{renderBody()}</tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default TimeOffModal;
